export enum Role {
  Admin = 'Admin',
  User = 'User',
  // Platform super-admin. Stored lowercase in User.roles (matches how 'admin'/'user'
  // are actually persisted); gates the super-admin console + impersonation endpoints.
  SuperAdmin = 'superadmin'
}
